import { put, select } from 'redux-saga/effects';
import { getAsyncActionResultSelector } from '~/hooks/useAsyncActionStatus';
import { logout, getLoggedUser } from '~/store/user/actions';
import { telli, perm, ticket } from '~/services';

type FailureMeta = { statusCode?: number; baseURL?: string };

export type FailureAction = { type: string; meta?: FailureMeta };

const AUTH_SERVICES = [telli, perm, ticket];

export const isAuthServiceRequest = (baseURL?: string): boolean => {
  if (!baseURL) {
    return false;
  }

  return AUTH_SERVICES.some((service) => {
    const host = service.getBaseWithoutPath?.();
    return !!host && (baseURL === host || baseURL.startsWith(`${host}/`));
  });
};

export function* requestErrorWatch({ meta }: FailureAction) {
  const { statusCode, baseURL } = meta || {};

  if (statusCode === 401 && isAuthServiceRequest(baseURL) && window.location.pathname !== '/login') {
    const loggedUserResult = yield select(getAsyncActionResultSelector(getLoggedUser));
    const fullPath = window.location.pathname + window.location.search;
    yield put(
      logout.start({
        redirectTo: fullPath,
        logoutTime: new Date(),
        userId: loggedUserResult?.id,
        userName: loggedUserResult?.name,
      }),
    );
  }
}
